import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';

export default class EntretienOptionsBtnComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
    }

    handleClick = (event) => {
        event.preventDefault();
        this.setState({
            open: true,
            anchorEl: event.currentTarget,
        });
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
        });
    };



    render() {
        return (
            <div className={"text-center"}>
                <RaisedButton
                    onClick={this.handleClick}
                    label="OPTIONS"
                />
                <Popover
                    open={this.state.open}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{horizontal: 'left', vertical: 'top'}}
                    targetOrigin={{horizontal: 'left', vertical: 'top'}}
                    onRequestClose={this.handleRequestClose}
                >
                    <Menu>
                        <MenuItem
                            primaryText="Reprendre l'entretien"
                            onClick={this.props.onClick1}
                        />
                        <MenuItem
                            primaryText="Voir un aperçu"
                            onClick={this.props.onClick2}
                        />
                        <MenuItem primaryText="Supprimer"
                                  onClick={this.props.onClick3}
                        />
                    </Menu>
                </Popover>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/EntretienOptionsBtnComponent.js